module.exports = __webpack_public_path__ + "img/user-gray.1036626d.svg";